"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslation = exports.resources = void 0;
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
Object.defineProperty(exports, "useTranslation", { enumerable: true, get: function () { return react_i18next_1.useTranslation; } });
const advanceSearch_1 = require("./en/advanceSearch");
const broadcastGroup_1 = __importDefault(require("./en/broadcastGroup"));
const calendar_1 = require("./en/calendar");
const changePassword_1 = __importDefault(require("./en/changePassword"));
const chat_1 = __importDefault(require("./en/chat"));
const common_1 = __importDefault(require("./en/common"));
const drawerHeader_1 = __importDefault(require("./en/drawerHeader"));
const exportChat_1 = __importDefault(require("./en/exportChat"));
const globalSettings_1 = __importDefault(require("./en/globalSettings"));
const groupChatInfo_1 = __importDefault(require("./en/groupChatInfo"));
const login_1 = __importDefault(require("./en/login"));
const lupa_1 = __importDefault(require("./en/lupa"));
const message_1 = __importDefault(require("./en/message"));
const networkInfo_1 = require("./en/networkInfo");
const organization_1 = __importDefault(require("./en/organization"));
const organizationMedia_1 = __importDefault(require("./en/organizationMedia"));
const patientGroup_1 = __importDefault(require("./en/patientGroup"));
const privateChatInfo_1 = __importDefault(require("./en/privateChatInfo"));
const resetPassword_1 = __importDefault(require("./en/resetPassword"));
const setPassword_1 = __importDefault(require("./en/setPassword"));
const settings_1 = __importDefault(require("./en/settings"));
const userDirectory_1 = __importDefault(require("./en/userDirectory"));
const userProfile_1 = __importDefault(require("./en/userProfile"));
const starredMessages_1 = __importDefault(require("./en/starredMessages"));
const quickReply_1 = __importDefault(require("./en/quickReply"));
const labRequisition_1 = __importDefault(require("./en/labRequisition"));
const internalGroup_1 = __importDefault(require("./en/internalGroup"));
const autoAck_1 = require("./en/autoAck");
const orgSettings_1 = require("./en/orgSettings");
exports.resources = {
    en: {
        common: common_1.default,
        login: login_1.default,
        organization: organization_1.default,
        message: message_1.default,
        chat: chat_1.default,
        patientGroup: patientGroup_1.default,
        drawerHeader: drawerHeader_1.default,
        groupChatInfo: groupChatInfo_1.default,
        exportChat: exportChat_1.default,
        privateChatInfo: privateChatInfo_1.default,
        userDirectory: userDirectory_1.default,
        broadcastGroup: broadcastGroup_1.default,
        settings: settings_1.default,
        globalSettings: globalSettings_1.default,
        resetPassword: resetPassword_1.default,
        setPassword: setPassword_1.default,
        changePassword: changePassword_1.default,
        advanceSearch: advanceSearch_1.advanceSearchTranslations,
        lupa: lupa_1.default,
        userProfile: userProfile_1.default,
        organizationMedia: organizationMedia_1.default,
        networkInfo: networkInfo_1.networkInfoTranslations,
        calendar: calendar_1.calendarTranslations,
        starredMessages: starredMessages_1.default,
        quickReply: quickReply_1.default,
        labRequisition: labRequisition_1.default,
        internalGroup: internalGroup_1.default,
        autoAck: autoAck_1.autoAck,
        orgSettings: orgSettings_1.orgSettings,
    },
};
i18next_1.default.use(react_i18next_1.initReactI18next).init({
    compatibilityJSON: "v4", //TODO: check if needed
    lng: "en", // if you're using a language detector, do not define the lng option
    debug: false,
    resources: exports.resources,
    defaultNS: "common",
    interpolation: {
        escapeValue: false, // React Native doesn't need HTML escaping
    },
    parseMissingKeyHandler: (key) => {
        return `XXXXXXXX${key}XXXXXXXX`;
    },
});
